import "bootstrap/dist/css/bootstrap.min.css";
import "./App.scss";
import "react-toastify/dist/ReactToastify.css";

import Map from "./components/Map/Map";
import ObjectCoordinates from "./data/datafile.json";
import React from "react";
import { ToastContainer } from "react-toastify";

let activeCategories = ["ST", "G", "N", "C", "P"];
let searchValue = "";
const App = () => {
  const filter = (catType: any, isActive: boolean) => {
    if (!isActive && catType === "ST") {
      let categoryIndex = activeCategories.indexOf("ST");
      if (categoryIndex > -1) activeCategories.splice(categoryIndex, 1);
    } else if (isActive && catType === "ST") {
      activeCategories.push("ST");
    }

    if (!isActive && catType === "G") {
      let categoryIndex = activeCategories.indexOf("G");
      if (categoryIndex > -1) activeCategories.splice(categoryIndex, 1);
    } else if (isActive && catType === "G") {
      activeCategories.push("G");
    }

    if (!isActive && catType === "N") {
      let categoryIndex = activeCategories.indexOf("N");
      if (categoryIndex > -1) activeCategories.splice(categoryIndex, 1);
    } else if (isActive && catType === "N") {
      activeCategories.push("N");
    }

    if (!isActive && catType === "C") {
      let categoryIndex = activeCategories.indexOf("C");
      if (categoryIndex > -1) activeCategories.splice(categoryIndex, 1);
    } else if (isActive && catType === "C") {
      activeCategories.push("C");
    }
    if (!isActive && catType === "P") {
      let categoryIndex = activeCategories.indexOf("P");
      if (categoryIndex > -1) activeCategories.splice(categoryIndex, 1);
    } else if (isActive && catType === "P") {
      activeCategories.push("P");
    }
    if (isActive && catType === "All") {
      activeCategories = [];
      activeCategories = ["ST", "G", "N", "C", "P"];
    }
  };
  const activeObjects = () => {
    return ObjectCoordinates.filter(function(el) {
      return (activeCategories.includes(el.Category) || el.Category === searchValue) && el.Caldwell_Messier.includes("M"); // Limit search to Messier
    });
  };
  return (
    <div className="App">
      <Map parentFilter={filter} activeCategories={activeCategories} ObjectCoordinates={activeObjects} />
      <ToastContainer autoClose={2000} position="bottom-right" hideProgressBar={true} />

    </div>
  );
};

export default App;
